import { UNSELECT_EDGE, UNSELECT_ALL, RESET_ALL_EDGES, RESET_EDGE,UNSELECT_EDGES} from "../../../actions"

export default function (oldUnselectedEdges, action) {
  switch (action.type) {
    case UNSELECT_EDGE:
      return [...oldUnselectedEdges, action.edgeId];
    case UNSELECT_EDGES:
      return [...oldUnselectedEdges, ...action.edgeIds];
    case RESET_EDGE:
      if(action.edgeId.includes('#')){
        return oldUnselectedEdges.filter(edge => edge !== action.edgeId);
      } else {
        const coreId = action.edgeId.split('#')[0];
        return oldUnselectedEdges.filter(edge => !edge.startsWith(coreId));
      }
      
    case RESET_ALL_EDGES:
    case UNSELECT_ALL:
      return [];
    default:
      return oldUnselectedEdges;
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/elements/edgeUnselection/index.js